import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthenticationService} from '../../modules/authentication/services/authentication.service';
import {map, Observable, take, tap} from 'rxjs';

export const signupValidationGuard: CanActivateFn = (): Observable<boolean> => {
  const _router = inject(Router);
  const _authService = inject(AuthenticationService);

  return _authService.hasValidationAccess$().pipe(
    take(1),
    tap(hasAccess => {
      if (!hasAccess) {
        _router.navigate(['/sign-up']);
      }
    }),
    map(hasAccess => hasAccess)
  );
};
